import { useSubscription } from "@/context/SubscriptionContext";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { PageHeader } from "@/layouts/PageHeader";
import { Progress } from "@/components/ui/progress";

export default function Usage() {
  const {
    planName,
    maxReports,
    maxAIGenerations,
    reportsUsed,
    aiGenerationsUsed,
    nextReset,
    loading,
    error,
  } = useSubscription();

  const atReportLimit = reportsUsed >= maxReports;
  const atAILimit = aiGenerationsUsed >= maxAIGenerations;

  return (
    <div className="px-10 py-9 max-w-[960px] mx-auto max-md:px-4 max-md:pt-5 max-md:pb-6">
      <PageHeader
        title="Usage"
        subtitle="Track your report card and AI generation usage."
      />

      {loading && <p className="text-muted-foreground">Loading...</p>}
      {error && <p className="text-destructive">Failed to load subscription info.</p>}

      {!loading && !error && (
        <div className="px-10 py-9 max-w-[600px] max-md:px-4 max-md:pt-5 max-md:pb-6">
          <div className="space-y-6">
            <div className="border border-border rounded-lg p-4 bg-card space-y-1">
              <p className="text-sm text-muted-foreground uppercase tracking-wide">Current plan</p>
              <p className="text-2xl font-semibold capitalize">{planName}</p>
            </div>

            <div className="border border-border rounded-lg p-4 bg-card space-y-4">
              <div className="space-y-1.5">
                <div className="flex justify-between text-sm">
                  <span>Report Cards</span>
                  <span className={atReportLimit ? "text-destructive font-semibold" : ""}>
                    {reportsUsed} / {maxReports}
                  </span>
                </div>
                <Progress value={reportsUsed} max={maxReports} />
              </div>

              <div className="space-y-1.5">
                <div className="flex justify-between text-sm">
                  <span>AI Generations</span>
                  <span className={atAILimit ? "text-destructive font-semibold" : ""}>
                    {aiGenerationsUsed} / {maxAIGenerations}
                  </span>
                </div>
                <Progress value={aiGenerationsUsed} max={maxAIGenerations} />
              </div>

              {nextReset && (
                <p className="text-xs text-muted-foreground pt-1">
                  Resets on {new Date(nextReset).toLocaleDateString()}
                </p>
              )}
            </div>

            {(atReportLimit || atAILimit) && (
              <div className="border border-[hsl(var(--destructive-border))] rounded-lg p-4 bg-[hsl(var(--destructive-bg))]">
                <p className="text-sm font-medium text-[hsl(var(--destructive-fg))] mb-2">You have reached your plan limit.</p>
                <Link to="/pricing">
                  <Button size="sm">Upgrade Plan</Button>
                </Link>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
